export function positionInvert(firstPosition: any, lastPosition: any) {
  return {
    x: firstPosition.left - lastPosition.left,
    y: firstPosition.top - lastPosition.top,
    scaleX: firstPosition.width / lastPosition.width,
    scaleY: firstPosition.height / lastPosition.height,
  };
}
